import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';

export const AnalyticsRoot = () => {
  const { pathname, search } = useLocation();

  useEffect(
    () =>
      ReactGA.initialize(process.env.REACT_APP_GA_KEY!, {
        debug: process.env.NODE_ENV === 'development',
      }),
    []
  );

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + search);
  }, [pathname, search]);

  return <></>;
};
